import Vue from "vue";
import Vuex from "vuex";
import BiologicalsStore from "./modules/biologicals";
import ChemicalReconciliationStore from "./modules/chemical_reconciliation_store";
import ChemtrackerSdsStore from "./modules/chemtracker_sds_store";
import DocumentStore from "./modules/raft_documents";
import FilterStore from "./modules/filters_store";
import HazardousWasteStore from "./modules/hazardous_waste_store";
import IncidentManagementStore from "./modules/incident_management_store";
import MedicalSurveillanceStore from "./modules/medical_surveillance";
import RaftMessagingStore from "./modules/raft_messaging_store";
import RequirementsStore from "./modules/requirements_store";
import SafetyObservationStore from "./modules/safety_observation";
import { useDrupalSettings } from "../composables/useDrupalSettings";

Vue.use(Vuex);

const includedModules = {
  BiologicalsStore,
  ChemicalReconciliationStore,
  ChemtrackerSdsStore,
  DocumentStore,
  FilterStore,
  HazardousWasteStore,
  incidentManagementStore: IncidentManagementStore,
  MedicalSurveillanceStore,
  RaftMessagingStore,
  RequirementsStore,
  SafetyObservationStore,
};

const { config, updateModule } = useDrupalSettings();

export default new Vuex.Store({
  modules: includedModules,
  state: {
    config: config,
  },
  getters: {
    config: (state) => state.config,
    getDestinationQuery() {
      let dest = "destination=" + window.location.pathname;
      // Handle query strings, especially gids[] in B3.
      if (window.location.search) {
        dest += encodeURIComponent(window.location.search);
      }
      return dest;
    },
  },
  mutations: {
    updateModule(state, module) {
      return updateModule(module);
    },
  },
});
